import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { usuariosApi, Usuario } from '../api/usuarios';
import { toast } from 'sonner';

export function useUsuarios() {
  return useQuery({
    queryKey: ['usuarios'],
    queryFn: () => usuariosApi.getAll(),
    staleTime: 1000 * 60 * 2,
  });
}

export function useUsuario(id: number) {
  return useQuery({
    queryKey: ['usuarios', id],
    queryFn: () => usuariosApi.getById(id),
    enabled: !!id && id > 0,
    staleTime: 1000 * 60 * 2,
  });
}

export function useCreateUsuario() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<Usuario> & { contrasena: string }) =>
      usuariosApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['usuarios'] });
      toast.success('Usuario creado exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al crear el usuario');
    },
  });
}

export function useUpdateUsuario() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<Usuario> & { contrasena?: string } }) =>
      usuariosApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['usuarios'] });
      toast.success('Usuario actualizado exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al actualizar el usuario');
    },
  });
}

export function useDeleteUsuario() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => usuariosApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['usuarios'] });
      toast.success('Usuario eliminado exitosamente');
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al eliminar el usuario');
    },
  });
}